import { Component, Input, SimpleChanges } from '@angular/core';
import { faCircleCheck, faCircleMinus, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { ResultsInvoice } from '../../files-clients/interface/company-client.interface';

@Component({
  selector: 'app-top-buy-invoces',
  templateUrl: './top-buy-invoces.component.html',
  styleUrls: ['./top-buy-invoces.component.scss']
})
export class TopBuyInvocesComponent {
  public icons = {faCircleMinus, faCircleCheck, faCircleXmark};
  public booleanCargandoBuyInvoces = true;
  public booleanCompras = false;
  @Input() topBuyInvoices: any;

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['topBuyInvoices'] && changes['topBuyInvoices'].currentValue !== undefined) {
    }
  }

  getRows(invoces: any[]): any[][] {
    const rows = [];
    for (let i = 0; i < invoces.length; i += 4) {
      rows.push(invoces.slice(i, i + 4));
    }
    return rows;
  }
}
